import { NgClass } from "@angular/common";
import { Component } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { AuthService } from "@ponder-core/auth/auth.service";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { NavigationService } from "@ponder-core/navigation/navigation.service";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { OverauthorizedComponent } from "@ponder-shared/components/overauthorized.component";
import e from "express";
import { distinctUntilChanged } from "rxjs";

@Component({
    imports: [ReactiveFormsModule, BusySpinComponent, NgClass, OverauthorizedComponent],
    templateUrl: "./login.component.html"
})
export class LoginComponent {
    public loginForm!: FormGroup;
    public isProcessing: boolean = false;
    public processingError?: string;

    public emailError?: string;
    public passwordError?: string;

    public constructor(formBuilder: FormBuilder, private events: EventBroker, private auth: AuthService, private navigation: NavigationService) {
        this.loginForm = formBuilder.group({
            email: ["", [Validators.required, Validators.email]],
            password: ["", [Validators.required, Validators.minLength(8), Validators.maxLength(64)]]
        });
        
        this.loginForm.get("email")!.valueChanges
            .pipe(distinctUntilChanged())
            .subscribe(() => {
                this.emailError = (this.loginForm.get("email")!.valid ? undefined : this.emailError);
                this.processingError = undefined;
            });

        this.loginForm.get("password")!.valueChanges
            .pipe(distinctUntilChanged())
            .subscribe(() => {
                this.passwordError = (this.loginForm.get("password")!.valid ? undefined : this.passwordError);
                this.processingError = undefined;
            });
    }

    public ngOnDestroy(): void {
        this.events.ui.restoreContentPaddingEvent.emit();
    }

    public ngOnInit(): void {
        this.events.ui.hideNavbarEvent.emit();
        this.events.ui.removeContentPaddingEvent.emit();
    }

    public onEmailLoseFocus(): void {
        this.emailError = undefined;
        var emailElement = this.loginForm.get("email")!;

        if (!emailElement.valid)
        {
            if ((emailElement.value as string).length == 0)
            {
                this.emailError = "Email address is required.";
            }
            else
            {
                this.emailError = "Invalid email address.";
            }
        }
    }

    public onPasswordLoseFocus(): void{
        this.passwordError = undefined;
        var passwordElement = this.loginForm.get("password")!;

        if (!passwordElement.valid)
        {
            var length = (passwordElement.value as string).length;

            if (length == 0)
            {
                this.passwordError = "Password is required.";
            }
            else if (length < 8 || length > 64)
            {
                this.passwordError = "Password must be between 8 and 64 characters.";
            }
        }
    }

    public canSubmit(): boolean {
        return this.loginForm.valid && !this.isProcessing && !this.processingError;
    }

    public async onSubmit() {
        if (!this.canSubmit()) {
            return;
        }

        this.isProcessing = true;
        this.processingError = undefined;
        this.loginForm.disable({ emitEvent: false });

        var response = await this.auth.loginAsync(this.loginForm.get("email")!.value, this.loginForm.get("password")!.value);

        if (!response.error) {
            this.navigation.back();
        } else {
            this.isProcessing = false;
            this.processingError = "Login failed.";
            this.loginForm.enable({ emitEvent: false });
        }
    }
}